import styled from 'foundations-theming-specialty/utils';
import { RemoveIcon } from 'breadcrumbs-ui/icons';
import TrackedButton from '../TrackedButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.div.withConfig({
  displayName: "FeedbackHeader__StyledHeader",
  componentId: "sc-1o23mc9-0"
})(({
  theme
}) => {
  return Object.assign({
    position: 'relative',
    display: 'flex',
    padding: `${theme.space['600']} ${theme.space['1300']} 0 !important`,
    justifyContent: 'space-between'
  }, theme.typography['heading-100'], {
    textAlign: 'center',
    color: `${theme.color['text-core-default']} !important`
  });
});
const StyledCloseButton = styled(TrackedButton)(({
  theme
}) => {
  return {
    display: 'flex',
    position: 'absolute',
    top: '14px',
    right: '18px',
    borderRadius: '50%',
    margin: 0,
    border: 0,
    padding: '5px',
    backgroundColor: 'transparent',
    svg: {
      display: 'flex',
      width: '12px',
      alignSelf: 'center',
      justifySelf: 'center',
      padding: 0,
      fill: theme.color['icon-core-default']
    }
  };
});
const FeedbackHeader = ({
  children,
  closeOnClick
}) => {
  return /*#__PURE__*/_jsxs(StyledHeader, {
    children: [children, /*#__PURE__*/_jsx(StyledCloseButton, {
      "data-test-id": "vertical-nav-feedback-close",
      onClick: closeOnClick,
      children: /*#__PURE__*/_jsx(RemoveIcon, {})
    })]
  });
};
export default FeedbackHeader;